import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { ErrorBoundary } from '@toss/error-boundary'
import { Suspense } from 'react'

import { USCIS_FORMS_MAP } from '@/lib/constants/uscis/form'

import { VisaBulletinTrendDialog } from '../../check-case/dialogs/visa-bulletin-trend-dialog/visa-bulletin-trend-dialog'
import { useFindTargetCase } from '../../hooks/use-find-target-case'
import { UpdateVisaBulletinInfoDialog } from '../dialogs/update-visa-bulletin-info-dialog'
import { CheckVisaBulletinErrorBoundary } from './error-boundary/check-visa-bulletin-error-boundary'
import { VisaBulletinInfoLoader } from './visa-bulletin-info-loader'
import { VisaBulletinInfo } from './visa-bulletin-info/visa-bulletin-info'

export const CheckVisaBulletin = () => {
  const { targetCase } = useFindTargetCase()

  const caseType = targetCase?.case_type
  const canCheckVisaBulletin =
    caseType === USCIS_FORMS_MAP['I-130'] ||
    caseType === USCIS_FORMS_MAP['I-140'] ||
    caseType === USCIS_FORMS_MAP['I-360']

  if (!targetCase || !canCheckVisaBulletin) {
    return null
  }

  return (
    <Suspense fallback={<VisaBulletinInfoLoader />}>
      <QueryErrorResetBoundary>
        {({ reset: resetQuery }) => (
          <ErrorBoundary
            renderFallback={({ reset: resetErrorBoundary }) => (
              <CheckVisaBulletinErrorBoundary reset={resetErrorBoundary} />
            )}
            onReset={resetQuery}
          >
            <VisaBulletinInfo />
          </ErrorBoundary>
        )}
      </QueryErrorResetBoundary>

      <UpdateVisaBulletinInfoDialog caseType={caseType} />
      <VisaBulletinTrendDialog />
    </Suspense>
  )
}
